
const $ = window.$;

export async function saveavatar(canvas, layers, assets){
	
	var items = [];
	
	for( let v of layers){
		items.push([
			assets.indexOf(v.asset),
			v.flipped,
			v.transform.translateX,
			v.transform.translateY,
			v.transform.scale,
			v.transform.rotate,
			v.showTransforms
		]);
		
	}
	
	var avatarsave = JSON.stringify([items]);
	var imagedata = canvas.toDataURL('image/jpeg', 0.9);
	
	return await (() => {
		return new Promise(resolve => {

			if( window.LOGGEDIN ){
				$.post( "/saveavatar", {
					"avatarsave_builder": avatarsave,
					"imagedata": imagedata,
					"fromeditor": true
				}, function( data ) {
					resolve(data.length > 0);
				}, "text");
			} else {
				localStorage.setItem("avatarsave_builder", avatarsave);
				localStorage.setItem("avatarimagedata", imagedata);
				
				$.post( "/uploadavatarimage", {
					"imagedata": localStorage.getItem("avatarimagedata")
				}, function( data ) {
					resolve(data.length > 0);
				}, "text");
			}

		});
	})();
	
}

export function loadavatar(layers, assets){
	var avatarsave;
	
	if( window.LOGGEDIN ){
		avatarsave = window.ACCOUNT_AVATARSAVE;
	} else {
		avatarsave = JSON.parse(localStorage.getItem("avatarsave_builder"));
	}
	
	if( !avatarsave ){
		
		return false;
	}
	
	for( let v of avatarsave[0]){
		layers.push({
			asset: assets[v[0]],
			flipped: v[1],
			transform: {
				translateX: v[2],
				translateY: v[3],
				scale: v[4],
				rotate: v[5],
			},
			showTransforms: v[6]
		});
	}
	
	return true;
}